
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/[slug]",
      function () {
        return require("private-next-pages/school/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/[slug]"])
      });
    }
  